import { Col, Row } from 'antd'
import React from 'react'
import { Container } from 'react-bootstrap'

const CheckIn = () => {
  return (
    <Container fluid>
    <Row className="mt-5 py-5">
      <Col>
        <div>
          <h4>Checkin!</h4>
        </div>
      </Col>
    </Row>
 
  </Container>
  )
}

export default CheckIn